/**
 * Keeps the same object reference while its inputs do not change.
 * Needed for template bindings that would otherwise get a new array on every check.
 */
export class MemoizedValue<T> {
  key: string | undefined;
  value: T | undefined;

  get(key: string, build: () => T): T {
    if (this.value === undefined || this.key !== key) {
      this.key = key;
      this.value = build();
    }

    return this.value;
  }
}
